import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", { d: "M12.5 10a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  d: "M10 5.5v-1M13.182 6.818l.707-.707M14.5 10h1M13.182 13.182l.707.707M10 15.5v-1M6.11 13.889l.708-.707M4.5 10h1M6.11 6.111l.708.707"
}, null, -1)
const _hoisted_3 = [
  _hoisted_1,
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M15.224 11.724a5.5 5.5 0 0 1-6.949-6.949 5.5 5.5 0 1 0 6.949 6.949Z" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]


	const __default__ = { name: 'ThemeSwitchSimple' } // name the component

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
		light: {
			type: String,
			default: 'stroke-zinc-900'
		},
		dark: {
			type: String,
			default: 'stroke-white'
		},
	},
  setup(__props) {

	/* eslint-disable-next-line */
	const props = __props
	
	function changeTheme() {
		// Whenever the user explicitly chooses light mode
		if (localStorage.theme === 'dark') localStorage.theme = 'light'

		// Whenever the user explicitly chooses dark mode
		else if (localStorage.theme === 'light') localStorage.theme = 'dark'

		let el: any = document?.querySelector("meta[name='theme-color']")

		if (localStorage.theme === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
			document.documentElement.classList.add('dark')
			if(el) el.content = "#111827"
		}
		else {
			document.documentElement.classList.remove('dark')
			if(el) el.content = "#FFFFFF"
		}
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (changeTheme()), ["prevent"])),
    class: "flex h-6 w-6 items-center justify-center rounded-md transition hover:bg-zinc-900/5 dark:hover:bg-white/5",
    "aria-label": "Switch to light theme"
  }, [
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 20 20",
      fill: "none",
      "aria-hidden": "true",
      class: _normalizeClass([__props.light, "h-5 w-5 dark:hidden"])
    }, _hoisted_3, 2)),
    (_openBlock(), _createElementBlock("svg", {
      viewBox: "0 0 20 20",
      fill: "none",
      "aria-hidden": "true",
      class: _normalizeClass([__props.dark, "hidden h-5 w-5 dark:block"])
    }, _hoisted_5, 2))
  ]))
}
}

})